import { format } from 'date-fns';
import { RangePreset } from '../../types/types';
import { DATE_API_FORMAT } from '../../constants';
import { getRangeForTimespan } from './getRangeForTimespan';
import { getSupportedDefaultMatchMode } from './getSupportedDefaultMatchMode';
import { getDefaultFilterValue, getIsBetweenMatchMode } from '../managerUtils';

export const getDefaultFilterFromApiResponse = (
  filterItem,
  fallbackType?: string
) => {
  const dateTimeTypes = ['date', 'dateTime'];
  let value = getDefaultFilterValue(filterItem);
  let matchMode = getSupportedDefaultMatchMode(filterItem, fallbackType);

  // isNull/isNotNull carry a boolean sentinel instead of the type's default value, which would otherwise leak into the param
  if (matchMode === 'isNull' || matchMode === 'isNotNull') {
    return {
      [matchMode === 'isNull' && value === false ? 'isNotNull' : matchMode]:
        true,
    };
  }

  if (
    dateTimeTypes.includes(filterItem.type) ||
    dateTimeTypes.includes(filterItem.control?.type)
  ) {
    const namedRange = getRangeForTimespan(value);
    if (namedRange.from) {
      if (getIsBetweenMatchMode(matchMode)) {
        value = `${format(namedRange.from, DATE_API_FORMAT)},${format(namedRange.to, DATE_API_FORMAT)}`;
      } else if (
        (Object.values(RangePreset) as string[]).includes(value as string)
      ) {
        // Range preset (e.g. last2Months) only applies to a 'between' matchMode; keep the filter but blank the value (stripped from requests, still shown).
        value = '';
      } else {
        value = format(namedRange.from, DATE_API_FORMAT);
      }
    }
  } else if (matchMode === 'isEmpty' && value === false) {
    matchMode = 'isNotEmpty';
    value = true;
  }
  return { [matchMode]: value };
};
